import { dew as _parseAccountDew } from "../../accounts/utils/parseAccount.js";
import { dew as _addressDew } from "../../errors/address.js";
import { dew as _nodeDew } from "../../errors/node.js";
import { dew as _transactionDew } from "../../errors/transaction.js";
import { dew as _isAddressDew } from "../address/isAddress.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.assertRequest = void 0;
  const parseAccount_js_1 = _parseAccountDew();
  const address_js_1 = _addressDew();
  const node_js_1 = _nodeDew();
  const transaction_js_1 = _transactionDew();
  const isAddress_js_1 = _isAddressDew();
  function assertRequest(args) {
    const {
      account: account_,
      gasPrice,
      maxFeePerGas,
      maxPriorityFeePerGas,
      to
    } = args;
    const account = account_ ? (0, parseAccount_js_1.parseAccount)(account_) : undefined;
    if (account && !(0, isAddress_js_1.isAddress)(account.address)) throw new address_js_1.InvalidAddressError({
      address: account.address
    });
    if (to && !(0, isAddress_js_1.isAddress)(to)) throw new address_js_1.InvalidAddressError({
      address: to
    });
    if (typeof gasPrice !== "undefined" && (typeof maxFeePerGas !== "undefined" || typeof maxPriorityFeePerGas !== "undefined")) throw new transaction_js_1.FeeConflictError();
    if (maxFeePerGas && maxFeePerGas > 2n ** 256n - 1n) throw new node_js_1.FeeCapTooHighError({
      maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new node_js_1.TipAboveFeeCapError({
      maxFeePerGas,
      maxPriorityFeePerGas
    });
  }
  exports.assertRequest = assertRequest;
  //# sourceMappingURL=assertRequest.js.map
  return exports;
}